"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckBoxToggle = _interopRequireDefault(require("../FormControl/CheckBoxToggle"));

var _ComboBox = _interopRequireDefault(require("../FormControl/ComboBox"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*

    1. input => inputFields (left block)
    2. output => outputFields (right block)
    3. onConfirm => func that returning (fields, format, isWithKeys),
    4. onCancel => optional func
    5. formatOptions => options for format ComboBox select (default selected first one)

*/
var Componator = function Componator(props) {
  var t = props.t,
      input = props.input,
      output = props.output,
      updateComponator = props.updateComponator,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      indexedField = props.indexedField,
      displayedField = props.displayedField,
      formatOptions = props.formatOptions;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isWithKeys = _useState2[0],
      setIsWithKeys = _useState2[1];

  var _useState3 = (0, _react.useState)({
    input: [],
    output: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = (0, _react.useState)(formatOptions && formatOptions[0].value || null),
      _useState6 = _slicedToArray(_useState5, 2),
      format = _useState6[0],
      setFormat = _useState6[1];

  var getBtnUpStatus = function getBtnUpStatus() {
    if (selected.output.length > 1) return true;

    if (selected.output.length !== 0) {
      var selectedIndex = findArrIndex(output, selected.output[0]);
      return [-1, 0].includes(selectedIndex);
    }

    return true;
  };

  var getBtnDownStatus = function getBtnDownStatus() {
    if (selected.output.length > 1) return true;

    if (selected.output.length !== 0) {
      var selectedIndex = findArrIndex(output, selected.output[0]);
      return [-1, output.length - 1].includes(selectedIndex);
    }

    return true;
  };

  var handleChange = function handleChange() {
    setIsWithKeys(!isWithKeys);
  };

  var getField = function getField(field, key) {
    var selectField = function selectField() {
      var selectedIndex = findArrIndex(selected[key], field);

      if (selectedIndex === -1) {
        setSelected(function (prevSelected) {
          return _objectSpread(_objectSpread({}, prevSelected), {}, _defineProperty({}, key, [].concat(_toConsumableArray(prevSelected[key]), [field])));
        });
      } else {
        setSelected(function (prevSelected) {
          return _objectSpread(_objectSpread({}, prevSelected), {}, _defineProperty({}, key, prevSelected[key].filter(function (_, index) {
            return index !== selectedIndex;
          })));
        });
      }
    };

    var moveDbl = function moveDbl() {
      var selectedIndex = findArrIndex(props[key], field);

      if (key === 'input') {
        updateComponator({
          input: input.filter(function (_, index) {
            return index !== selectedIndex;
          }),
          output: [].concat(_toConsumableArray(output), [input[selectedIndex]])
        });
      }

      if (key === 'output') {
        updateComponator({
          input: [].concat(_toConsumableArray(input), [output[selectedIndex]]),
          output: output.filter(function (_, index) {
            return index !== selectedIndex;
          })
        });
      }
    };

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: field[displayedField],
      className: "field ".concat(selected[key].find(function (v) {
        return v[indexedField] === field[indexedField];
      }) ? 'selected' : ''),
      onClick: selectField,
      onDoubleClick: moveDbl
    }, t(field[displayedField]));
  };

  var findArrIndex = function findArrIndex(arr, val) {
    return arr.findIndex(function (v) {
      return v[indexedField] === val[indexedField];
    });
  };

  var moveAllIn = function moveAllIn() {
    updateComponator({
      input: [],
      output: [].concat(_toConsumableArray(output), _toConsumableArray(input))
    });
  };

  var moveAllOut = function moveAllOut() {
    updateComponator({
      input: [].concat(_toConsumableArray(input), _toConsumableArray(output)),
      output: []
    });
  };

  var moveIn = function moveIn() {
    var keys = selected.input.map(function (v) {
      return v[indexedField];
    });
    updateComponator({
      input: input.filter(function (v) {
        return !keys.includes(v[indexedField]);
      }),
      output: output.concat(selected.input)
    });
  };

  var moveOut = function moveOut() {
    var keys = selected.output.map(function (v) {
      return v[indexedField];
    });
    updateComponator({
      input: input.concat(selected.output),
      output: output.filter(function (v) {
        return !keys.includes(v[indexedField]);
      })
    });
  };

  var moveUp = function moveUp() {
    var index = findArrIndex(output, selected.output[0]);
    output.splice(index, 1);
    output.splice(index - 1, 0, selected.output[0]);
    updateComponator({
      output: output
    });
  };

  var moveDown = function moveDown() {
    var index = findArrIndex(output, selected.output[0]);
    output.splice(index, 1);
    output.splice(index + 1, 0, selected.output[0]);
    updateComponator({
      output: output
    });
  };

  var handleConfirm = function handleConfirm() {
    onConfirm(output, format.value || format, isWithKeys);
  };

  (0, _react.useEffect)(function () {
    setSelected({
      input: [],
      output: []
    });
  }, [input, output]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator"
  }, formatOptions && /*#__PURE__*/_react["default"].createElement(_ComboBox["default"], {
    className: "container-combo-box",
    classNamePrefix: "select",
    key: "format-select",
    name: "format-select",
    label: t('exportFormat'),
    placeholder: t('placeholder'),
    options: formatOptions,
    input: {
      onChange: setFormat,
      value: format
    },
    clearable: false
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-title"
  }, t('fieldsForExport')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-input"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-title"
  }, t('availableFields')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-fields"
  }, input.map(function (v) {
    return getField(v, 'input');
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-handlers"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn",
    disabled: !input.length,
    onClick: moveAllIn
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-chevron-double-right"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn",
    disabled: !selected.input.length,
    onClick: moveIn
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-arrow-right"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn",
    disabled: !selected.output.length,
    onClick: moveOut
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-arrow-left"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn",
    disabled: !output.length,
    onClick: moveAllOut
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-chevron-double-left"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-output"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-title"
  }, t('selectedFields')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-fields"
  }, output.map(function (v) {
    return getField(v, 'output');
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "componator-handlers"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn",
    disabled: getBtnUpStatus(),
    onClick: moveUp
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-up"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn",
    disabled: getBtnDownStatus(),
    onClick: moveDown
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon-down"
  })))), /*#__PURE__*/_react["default"].createElement("footer", {
    className: "componator-footer"
  }, /*#__PURE__*/_react["default"].createElement(_CheckBoxToggle["default"], {
    key: "add-field-keys",
    name: "add-field-keys",
    label: t('addFieldKeys'),
    checked: isWithKeys,
    onChange: handleChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "footer-buttons"
  }, onCancel && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "btn-cancel-circle",
    onClick: onCancel,
    text: t('Cancel')
  }), onConfirm && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "btn-save-circle",
    disabled: output.length === 0,
    text: t('download'),
    onClick: handleConfirm
  }))));
};

Componator.propTypes = {
  t: _propTypes["default"].func,
  input: _propTypes["default"].array,
  output: _propTypes["default"].array,
  onConfirm: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  updateComponator: _propTypes["default"].func,
  indexedField: _propTypes["default"].string,
  displayedField: _propTypes["default"].string,
  formatOptions: _propTypes["default"].array
};
var _default = Componator;
exports["default"] = _default;